module.exports = __webpack_public_path__ + "img/metamask_two.0b0d62b6.png";